import styled from 'astroturf/react'
import { HtmlParser } from '@calendly/html-parser'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useSelector } from 'react-redux'

import { shouldHideDossierSelector } from 'selectors/profile'

import { EventTypeCard } from './event_type_card'
import { CookieSettingsButton } from './styles'
import _Container from "landing_page-Container.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/landing_page/landing_page.js?styleId=Container";
import _EventTypesSection from "landing_page-EventTypesSection.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/landing_page/landing_page.js?styleId=EventTypesSection";
import _Description from "landing_page-Description.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/landing_page/landing_page.js?styleId=Description";
import _Header from "landing_page-Header1.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/landing_page/landing_page.js?styleId=Header1";
import _Header2 from "landing_page-Header2.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/landing_page/landing_page.js?styleId=Header2";
import _LogoSectionWrapper from "landing_page-LogoSectionWrapper.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/landing_page/landing_page.js?styleId=LogoSectionWrapper";
import _LogoImage from "landing_page-LogoImage.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/landing_page/landing_page.js?styleId=LogoImage";


const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container,
  attrs: props => ({
    ...props,
    isTabletUp: useDeviceType('isTabletUp')
  })
})
const EventTypesSection = /*#__PURE__*/styled('section', null, {
  displayName: "EventTypesSection",
  styles: _EventTypesSection,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})
const Description = /*#__PURE__*/styled('div', null, {
  displayName: "Description",
  styles: _Description,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})
const Header1 = /*#__PURE__*/styled('h1', null, {
  displayName: "Header1",
  styles: _Header
})
const Header2 = /*#__PURE__*/styled('h2', null, {
  displayName: "Header2",
  styles: _Header2
})
const LogoSectionWrapper = /*#__PURE__*/styled('section', null, {
  displayName: "LogoSectionWrapper",
  styles: _LogoSectionWrapper
})
const LogoImage = /*#__PURE__*/styled('img', null, {
  displayName: "LogoImage",
  styles: _LogoImage
})

const LogoSection = ({ landingPage }) => {
  if (landingPage.display_image) {
    return (
      <LogoSectionWrapper id="logo" data-testid="landing_page_section">
        <LogoImage
          src={landingPage.display_image}
          isAvatar={landingPage.image_format === 'avatar'}
          alt
        />
      </LogoSectionWrapper>
    )
  }

  return null
}

const DEFAULT_LAYOUT = '1,2,3'

const EditField = ({ type, landingPage }) => {
  const shouldHideDossier = useSelector(shouldHideDossierSelector)

  if (shouldHideDossier && (type === '1' || type === '2')) { return null }

  switch (type) {
    case '1':
      return <LogoSection landingPage={landingPage} />
    case '2':
      return !landingPage.description ? null : (
        <Description id="description" data-testid="landing_page_section">
          {HtmlParser(landingPage.description, { h1: Header1, h2: Header2 })}
        </Description>
      )
    case '3':
      return (
        <EventTypesSection id="eventTypes" data-testid="landing_page_section">
          {landingPage.event_types && landingPage.event_types?.map(
            (eventType) => <EventTypeCard key={eventType.url} eventType={eventType} />)}
        </EventTypesSection>
      )
    default:
      return null
  }
}

export const LandingPage = ({ landingPage }) => (
  <Container>
    {(landingPage.layout || DEFAULT_LAYOUT).split(',').map(
      (number) => <EditField key={number} type={number} landingPage={landingPage} />
    )}
    <CookieSettingsButton />
  </Container>
)
